import React from 'react'
import { Users, Heart, Shield, Home } from 'lucide-react'

const WhoWeServe = () => {
  const clientGroups = [
    {
      icon: Users,
      title: 'Seniors',
      description: 'We provide compassionate support for older adults who want to age in place with dignity and independence. Our services help seniors maintain their quality of life while staying in the comfort of their own homes.',
    },
    {
      icon: Heart,
      title: 'Adults with Disabilities',
      description: 'Our team offers personalized care and support for adults with physical, developmental, or cognitive disabilities. We focus on promoting independence and helping individuals live fulfilling lives in their communities.',
    },
    {
      icon: Shield,
      title: 'Individuals Needing Daily Living Support',
      description: 'Whether recovering from illness, surgery, or managing chronic conditions, we provide the assistance needed to maintain safety and comfort at home. Our services adapt to changing needs and circumstances.',
    },
    {
      icon: Home,
      title: 'Families Needing Dependable In-Home Care',
      description: 'We partner with families to provide reliable, professional care for their loved ones. Our services give family caregivers peace of mind and much-needed respite while ensuring their loved ones receive quality support.',
    },
  ]

  return (
    <div className="min-h-screen" data-component-path="client/src/pages/WhoWeServe.jsx" data-component-line="1:1" data-component-id="client/src/pages/WhoWeServe.jsx:1:1">
      <section className="bg-gradient-to-br from-auburn-50 via-white to-stone-50 py-20" data-component-path="client/src/pages/WhoWeServe.jsx" data-component-line="3:3" data-component-id="client/src/pages/WhoWeServe.jsx:3:3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/WhoWeServe.jsx" data-component-line="4:4" data-component-id="client/src/pages/WhoWeServe.jsx:4:4">
          <div className="text-center max-w-3xl mx-auto" data-component-path="client/src/pages/WhoWeServe.jsx" data-component-line="5:5" data-component-id="client/src/pages/WhoWeServe.jsx:5:5">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6" data-component-path="client/src/pages/WhoWeServe.jsx" data-component-line="6:6" data-component-id="client/src/pages/WhoWeServe.jsx:6:6">Who We Serve</h1>
            <p className="text-xl text-gray-600 leading-relaxed" data-component-path="client/src/pages/WhoWeServe.jsx" data-component-line="7:7" data-component-id="client/src/pages/WhoWeServe.jsx:7:7">
              We're honored to serve a diverse community of individuals and families who need compassionate, reliable support to maintain independence and quality of life at home.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white" data-component-path="client/src/pages/WhoWeServe.jsx" data-component-line="16:16" data-component-id="client/src/pages/WhoWeServe.jsx:16:16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/WhoWeServe.jsx" data-component-line="17:17" data-component-id="client/src/pages/WhoWeServe.jsx:17:17">
          <div className="grid md:grid-cols-2 gap-8" data-component-path="client/src/pages/WhoWeServe.jsx" data-component-line="18:18" data-component-id="client/src/pages/WhoWeServe.jsx:18:18">
            {clientGroups.map((group, index) => (
              <div
                key={index}
                className="bg-stone-50 p-8 rounded-xl hover:shadow-lg transition-shadow duration-200 border border-gray-200"
                data-component-path="client/src/pages/WhoWeServe.jsx"
                data-component-line="19:19"
                data-component-id="client/src/pages/WhoWeServe.jsx:19:19"
              >
                <div className="flex flex-col gap-6" data-component-path="client/src/pages/WhoWeServe.jsx" data-component-line="25:25" data-component-id="client/src/pages/WhoWeServe.jsx:25:25">
                  <div className="w-16 h-16 bg-auburn-100 rounded-full flex items-center justify-center flex-shrink-0" data-component-path="client/src/pages/WhoWeServe.jsx" data-component-line="26:26" data-component-id="client/src/pages/WhoWeServe.jsx:26:26">
                    <group.icon className="w-8 h-8 text-auburn-600" data-component-path="client/src/pages/WhoWeServe.jsx" data-component-line="27:27" data-component-id="client/src/pages/WhoWeServe.jsx:27:27" />
                  </div>
                  <div data-component-path="client/src/pages/WhoWeServe.jsx" data-component-line="29:29" data-component-id="client/src/pages/WhoWeServe.jsx:29:29">
                    <h2 className="text-3xl font-bold text-gray-900 mb-4" data-component-path="client/src/pages/WhoWeServe.jsx" data-component-line="30:30" data-component-id="client/src/pages/WhoWeServe.jsx:30:30">{group.title}</h2>
                    <p className="text-lg text-gray-600 leading-relaxed" data-component-path="client/src/pages/WhoWeServe.jsx" data-component-line="31:31" data-component-id="client/src/pages/WhoWeServe.jsx:31:31">{group.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-auburn-600" data-component-path="client/src/pages/WhoWeServe.jsx" data-component-line="41:41" data-component-id="client/src/pages/WhoWeServe.jsx:41:41">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-component-path="client/src/pages/WhoWeServe.jsx" data-component-line="42:42" data-component-id="client/src/pages/WhoWeServe.jsx:42:42">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6" data-component-path="client/src/pages/WhoWeServe.jsx" data-component-line="43:43" data-component-id="client/src/pages/WhoWeServe.jsx:43:43">
            Let Us Support You or Your Loved One
          </h2>
          <p className="text-xl text-auburn-50 leading-relaxed mb-8" data-component-path="client/src/pages/WhoWeServe.jsx" data-component-line="46:46" data-component-id="client/src/pages/WhoWeServe.jsx:46:46">
            Every individual deserves compassionate care and support. Contact us today to learn how we can help you or your family member live safely and independently at home.
          </p>
          <a
            href="/contact"
            className="inline-flex items-center justify-center gap-2 h-14 px-8 bg-white text-auburn-600 rounded-lg hover:bg-gray-50 transition-all duration-200 shadow-lg hover:shadow-xl focus:ring-4 focus:ring-white/50 text-lg font-semibold"
            data-component-path="client/src/pages/WhoWeServe.jsx"
            data-component-line="50:50"
            data-component-id="client/src/pages/WhoWeServe.jsx:50:50"
          >
            Get Started Today
          </a>
        </div>
      </section>
    </div>
  )
}

export default WhoWeServe